import { Component, OnInit, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Button, DocumentTypes, PartType } from '../../../../../shared/model/enum';
import { AgGridI } from '../../../../../shared/components/ag-grid/ag-grid.model';
import { AgGridComponent } from '../../../../../shared/components/ag-grid/ag-grid.component';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { agGridDataModelImages } from '../../pages/part-inventory/in-stock/instock.model';
import { PaginationModel } from '../../../../../shared/model/pagination.model';
import { UploadDocumentsComponent } from '../../../../crm/companies/pages/company-info-tabs/pop-ups/upload-documents/upload-documents.component';
import { ModalPopupSize } from '../../../../../shared/model/common.model';
import { UploadDocumentsEnum } from '../../../../crm/companies/pages/company-info-tabs/settings-tab/settings-tab.model';
import { PartsListService } from '../../pages/parts-list/parts-list.service';

@Component({
  selector: 'app-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss']
})
export class ImagesComponent implements OnInit {
  title
  data:any ={}
  enumButtonName = Button;
  AgGridDataModel: AgGridI;
  gridApiForDataModel: any
  selectedData = []
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>

  constructor(public activeModal: NgbActiveModal,public toaster: ToastrService,
      public renderer: Renderer2,
       public sendDataService: SendDataService,
       public partsListService: PartsListService,
        ) {}
 

  ngOnInit(): void {
        this.AgGridDataModel = agGridDataModelImages;
        if(this.data?.imagesUpload?.length > 0){
          this.data.imageUploadList =  this.data?.imagesUpload[0]?.imageUploadList ?? [] ;
        }
        this.getByID()
  }
  getByID(){
    if(!this.data?.editable)return
    this.partsListService.getDocumentByInventoryLineId({inventoryLineId:this.data?.inventoryLineId}).subscribe((res) => {
      if (res?.isSuccess) {
        this.data.imageUploadList = res?.response??[]
        this.gridApiForDataModel?.api?.setRowData( this.data?.imageUploadList);
      } 
    }
  );
  }
   onPagination(pagination: PaginationModel) {
    }
    getRowStyle = (params: any) => {
      return { borderBottom: '1px solid #E9EDF2' };
    };
    onSelectionChange(params) {
      this.selectedData = params?.api?.getSelectedRows();
    }
    deleteRow() {
    if(this.data?.editable)return
    let selectedData = this.gridApiForDataModel?.api?.getSelectedRows();
    if(selectedData?.length == 0)return
    if (Array.isArray(this.data?.imageUploadList)) {
      let ID = selectedData?.map((items) => { return items.id; })
      let reqData = { ids: ID ?? [] }
      this.partsListService.deleteTempDocumentById(reqData).subscribe((res) => {
        if (res.isSuccess) {
          this.data.imageUploadList = this.data.imageUploadList.filter(
            item => !selectedData.some(selected => selected.id === item.id)
          );
          this.toaster.success(res?.message);
          this.gridApiForDataModel?.api?.updateRowData({ remove: selectedData });
        }
      });
    }
  }
    onGridReady(event) {
      this.gridApiForDataModel = event;
      this.getList();
  }
  getList() {
    if (this.grids?.first) {
      this.grids.first.agGridPaginationConfig.rows = this.data?.imageUploadList??[];
    }
  }
  
    openUploadImagesPopup() {
      const data = {
        pageType:UploadDocumentsEnum.LINEINFORMATION
      }
      this.sendDataService.openModalPopup(UploadDocumentsComponent, data, 'Upload Image', ModalPopupSize.LG,'upload-image-popup has-parent-popup').then(
        (resultData) => {
          if (resultData?.confirm) {
            if(!resultData?.data?.file){
              this.toaster.error("Please upload file.")
              return
            }
            this.uploadImage(resultData?.data)
          }
        }
      );
    }
  uploadImage(data){
    const requestModel = { 
      partId:this.data?.mpnId??'',
      sourceId:'',
      file:data?.file??'',
      documentTypeId:this.data?.consignmentDetail?DocumentTypes?.partConsignment:DocumentTypes?.partInventory,
      fileName:data?.fileName??'',
      partTypeId:this.data?.consignmentDetail?PartType.PartConsignment:PartType.PartInventory,
      categoryId:'',
      isSplitLine: true
     };
    this.partsListService.uploadTempDocument(requestModel).subscribe((res) => {
        if (res?.isSuccess) {
          this.data.imageUploadList = this.data?.imageUploadList??[]
          this.data?.imageUploadList?.push(res?.response)
          this.toaster.success(res?.message);
          this.gridApiForDataModel?.api?.setRowData( this.data?.imageUploadList);
        } 
      }
    );
  }
}
